module.exports = __webpack_public_path__ + "static/media/FloorScrape2_Before.41ff6bf6.jpg";